export default function (obj, path){
  let r = obj;
  for(let a = 0; a < path.length; a++){
    r = r[path[a]];
    if(r===undefined) return r;
  }
  return r;
}